<template>
    <v-data-table
        dense
        :headers="headers"
        :items="data"
        :loading="loading"
        hide-default-footer
        disable-pagination
        disable-sort
        >
        <template v-slot:[`item.text`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.payment_account.create)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.text}}
        </template>
    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "PurchasePaymentModeList",
    data() {
        return {
            headers: [
                { text: "Payment Mode", value: "text" },
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            data: "purchase/paymentMode/list",
            loading: "purchase/paymentMode/loading",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            index: "purchase/paymentMode/index"
        }),
        handleClickRow(item){  
            this.$router.push({ name: 'PurchasePaymentModeDisplay', params: { id: item.value }})
        }
    },
    created() {
        this.index();
    }
}
</script>

<style>

</style>